export const urlToGetOneCourse =
  'https://api.whatsapp.com/send?phone=17867892469&text=Hola%20%F0%9F%98%8A%2C%20quisiera%20informaci%C3%B3n%20sobre%20los%20cursos%20y%20rutas%20de%20Crack%20The%20Code.';

export const urlToGetLearningPath =
  'https://api.whatsapp.com/send?phone=17867892469&text=Hola%20%F0%9F%98%8A%2C%20quisiera%20informaci%C3%B3n%20sobre%20los%20cursos%20y%20rutas%20de%20Crack%20The%20Code.';
